import React from "react";
import { Wrench } from "lucide-react";

export default function Logo({ dark = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="mobilhub-logo">
      <div className="relative flex items-center justify-center w-9 h-9 rounded-lg bg-electric">
        <Wrench className="w-5 h-5 text-white" strokeWidth={2.5} />
        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-warm border-2 border-navy" />
      </div>
      <span className={`font-heading text-xl font-bold tracking-tight leading-none ${dark ? "text-navy" : "text-white"}`}>
        Mobil<span className="text-warm">Hub</span>
      </span>
    </div>
  );
}
